module.exports = __webpack_public_path__ + "static/media/p5_10.194f18b6.jpeg";